<template>
    <div
        class="form-horizontal"
        enctype="multipart/form-data"
        @submit.prevent="store"
        @keydown="form.errors.clear($event.target.name)"
    >
        <table class="table table-striped">
            <tr>
                <th>{{ uLang("app.name") }}</th>
                <th>{{ uLang('app.action') }}</th>
            </tr>
            <tr v-for="applicationActivityType in applicationActivityTypes">
                <td>
                    <input
                        type="text"
                        v-if="applicationActivityType.editable"
                        class="form-control"
                        :name="applicationActivityType.value"
                        v-model="form['value'][applicationActivityType.id]"
                    />
                    <span v-if="!applicationActivityType.editable">
                        {{ applicationActivityType.value }}
                    </span>
                </td>
                <td>
                    <a href="#" @click.prevent="removeApplicationActivityType(applicationActivityType)" class="btn btn-danger" v-if="applicationActivityType.deleteable" :title="uLang('app.delete_document_type')">
                        <i class="fa fa-trash"></i>
                    </a>
                </td>
            </tr>
        </table>

        <div class="form-group">
            <div class="input-group">
                <input
                    type="text"
                    class="form-control"
                    name="new"
                    v-model="newApplicationActivityType"
                    placeholder="Type hier uw sollicatieactiviteittype"
                    title="Voeg nieuwe sollicitatieactiviteiten types toe"
                />
                <span class="input-group-btn">
                    <button
                        type="button"
                        class="btn btn-success"
                        @click="addApplicationActivityType"
                        :disabled="form.busy || !newApplicationActivityType"
                    >
                      {{ uLang("app.add_activity_type", { type: lang("app.application_activity_type") }) }}
                    </button>
                </span>
            </div>
        </div>

        <div class="form-group">
            <input
                :disabled="form.busy"
                type="button"
                :value="uLang('app.save_setting')"
                @click="store()"
                class="btn btn-brand"
            />
        </div>
    </div>
</template>

<script>
    import Form from "~/Form/Form";
    import { ErrorAlert, SuccessAlert, DestroyAlert } from "~/Swals";

    export default {
        name: "form-setting-application-activity-type",
        props: {
            settingId: {
                required: true,
            },
        },
        data() {
            return {
                form: new Form({
                    value: {},
                }),
                newApplicationActivityType: "",
                applicationActivityTypes: [],
            };
        },
        mounted: function () {
            this.retrieveValues();
        },
        methods: {
            async store() {
                this.form["patch"]("/api/admin/settings/" + this.settingId)
                    .then((response) => {
                        this.setValues(response);
                        new SuccessAlert({
                            text: this.uLang(
                                "app.application_activity_type_successfully_updated",
                                { type: lang("app.application_activity_type") }
                            ),
                        }).show();
                    })
                    .catch((error) => {
                        new ErrorAlert({
                            title: uLang("app.oops_something_went_wrong"),
                            text: uLang("app.all_inputs_need_to_be_filled"),
                        }).show();
                    });
            },

            setValues(data) {
                this.form.value = {};

                this.applicationActivityTypes = data;

                data.forEach(function (applicationActivityType) {
                    if (applicationActivityType.editable) {
                        this.value[applicationActivityType.id] =
                            applicationActivityType.value;
                    }
                }, this.form);
            },

            async retrieveValues() {
                const { data } = await window.axios.get(
                    "/api/admin/settings/" + this.settingId + "/values"
                );

                this.setValues(data);
            },

            addApplicationActivityType() {
                if (this.newApplicationActivityType === "") return;

                this.applicationActivityTypes.push({
                    id: this.newApplicationActivityType,
                    value: this.newApplicationActivityType,
                    deleteable: 1,
                    editable: 1,
                });
                this.form.value[this.newApplicationActivityType] = this.newApplicationActivityType;
                this.newApplicationActivityType = "";
            },

            removeApplicationActivityType(ApplicationActivityType) {
                new DestroyAlert({ entity: this.lang("app.application_activity_type") })
                    .show()
                    .then(async () => {
                        delete this.form.value[ApplicationActivityType.id];

                        this.applicationActivityTypes = this.applicationActivityTypes.filter(
                            function (currentApplicationStatus) {
                                return (
                                    currentApplicationStatus.value != ApplicationActivityType.value
                                );
                            }
                        );
                    });
            },
        },
    };
</script>

<style lang="css" scoped></style>
